/**
 * En-tête de la feuille journalière
 * Affiche les infos de la prestation (lieu hérité) et les champs modifiables (distance, notes)
 */

import React from 'react';

const STATUS_LABELS = {
  new: { label: 'Nouvelle', color: '#2196F3' },
  draft: { label: 'Brouillon', color: '#9E9E9E' },
  submitted: { label: 'Soumis', color: '#FF9800' },
  validated: { label: 'Validé', color: '#4CAF50' },
  rejected: { label: 'Rejeté', color: '#F44336' }
};

const WorksheetHeader = ({
  workDate,
  prestation,
  headerData,
  onHeaderChange,
  status,
  isEditable,
  onClose,
  worksheetId
}) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Déterminer le statut réel : 'new' si pas encore créée en BDD
  const effectiveStatus = !worksheetId ? 'new' : status;
  const statusInfo = STATUS_LABELS[effectiveStatus] || STATUS_LABELS.draft;

  return (
    <div className="worksheet-header">
      <div className="header-top">
        <div className="header-title">
          <h2>Feuille Journalière de Travail</h2>
          <span className="ref-number">ERQ.RH.08</span>
        </div>

        <div className="header-status">
          <span
            className="status-badge"
            style={{ backgroundColor: statusInfo.color }}
          >
            {statusInfo.label}
          </span>
        </div>

        <button className="close-button" onClick={onClose} title="Fermer">
          &times;
        </button>
      </div>

      <div className="header-info">
        <div className="info-row compact">
          <div className="info-field">
            <label>Date</label>
            <span className="value date-value">{formatDate(workDate)}</span>
          </div>

          <div className="info-field">
            <label>Groupe</label>
            <span className="value">{prestation?.group_name || '-'}</span>
          </div>

          <div className="info-field">
            <label>Chantier</label>
            <span className="value">
              {prestation?.prestation_number || '-'}
              {prestation?.client_name && <span className="client-name"> - {prestation.client_name}</span>}
            </span>
          </div>

          <div className="info-field location-field">
            <label>Lieu</label>
            <span className="value">
              {prestation?.location_name
                ? `${prestation.location_name}${prestation.location_city ? ` (${prestation.location_city})` : ''}`
                : prestation?.group_city || '-'}
            </span>
          </div>

          <div className="info-field editable distance">
            <label htmlFor="distance_km">KM</label>
            {isEditable ? (
              <input
                type="number"
                id="distance_km"
                value={headerData.distance_km}
                onChange={(e) => onHeaderChange('distance_km', e.target.value)}
                placeholder="0"
                min="0"
                step="0.1"
              />
            ) : (
              <span className="value">{headerData.distance_km || '0'}</span>
            )}
          </div>

          <div className="info-field editable notes-field">
            <label htmlFor="notes">Notes</label>
            {isEditable ? (
              <input
                type="text"
                id="notes"
                value={headerData.notes || ''}
                onChange={(e) => onHeaderChange('notes', e.target.value)}
                placeholder="Observations..."
              />
            ) : (
              <span className="value">{headerData.notes || '-'}</span>
            )}
          </div>
        </div>

        {(status === 'rejected' && prestation?.rejection_reason) && (
          <div className="rejection-notice">
            <strong>Motif de rejet :</strong> {prestation.rejection_reason}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorksheetHeader;
